import React from "react";
import { set } from "dot-prop-immutable";
import { SimpleForm as Form, Input, Switch, Collapse } from '@whalecloud/fdx';
import { toolFormAttr, toolCollapseAttr, getLocale } from "@utils/util";
import DataSettings from './DataSettings';
import ColumnSettings from './ColumnSettings';

const { Panel } = Collapse;

const valueKey = 'data.tableSettings';

const TableEditSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formSettings = {}, tableSettings = {}, settings = {} } = {} } = element;
  const { name, label } = formSettings;

  const {
    visible = true
  } = settings

  const {
    autoInitialize,
    rowSelection,
    insertable,
    removeable,
    upmoveable,
    downmoveable,
    operateFirst,
  } = tableSettings;

  const initialValues = {
    name,
    label,
    autoInitialize,
    visible,
    rowSelection,
    insertable,
    removeable,
    upmoveable,
    downmoveable,
    operateFirst
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let propName = `${valueKey}.${key}`;
      let value = obj[key];
      if (key === 'rowSelection') {
        value = obj[key] ? {} : null;
      }
      if (key === 'visible') {
        propName = `data.settings.${key}`;
        value = obj[key] ? 'visible' : 'hidden';
      }
      if (['name', 'label'].includes(key)) {
        propName = `data.formSettings.${key}`;
      }
      const newElement = set(element, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_NAME']} name="name">
            <Input />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_LABEL_TEXT']} name="label">
            <Input />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_AUTO_INITILIZE']} name="autoInitialize" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_VISIBLE']} name="visible" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_MULTIPLE']} name="rowSelection" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_INSERTABLE']} name="insertable" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_REMOVEABLE']} name="removeable" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_UPMOVEABLE']} name="upmoveable" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_DOWNMOVEABLE']} name="downmoveable" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['ORDER_FIRST']} name="operateFirst" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_FORM_TABS_DATA']} key="2">
        <DataSettings element={element} updateElement={updateElement} />
        <ColumnSettings updateElement={updateElement} />
      </Panel>
    </Collapse>
  );
};

export default TableEditSettings;
